import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCoins03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="currentColor" d="M7.203 7.203a8 8 0 1 0 3.595 15.595A8 8 0 0 0 7.202 7.202Z" />
    <path
      fill="currentColor"
      d="M8.044 5.045C8.36 5.015 8.678 5 9 5c5.523 0 10 4.477 10 10 0 .322-.015.641-.045.956a8 8 0 1 0-10.91-10.91Z"
    />
  </svg>
);
SvgCoins03.displayName = 'Coins03';
export default SvgCoins03;
